/* @usb-ui-tools/react-component-lib v1.0.0 © 2022 U.S. Bank - UXTechnology */
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var MicroAppLoader = function (_a) {
    var _b = _a.addClasses, addClasses = _b === void 0 ? '' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? '' : _c, id = _a.id, elementRef = _a.elementRef, manifestPath = _a.manifestPath, namespace = _a.namespace, _d = _a.appProps, appProps = _d === void 0 ? {} : _d, _e = _a.isDomainPrefixedToManifestPath, isDomainPrefixedToManifestPath = _e === void 0 ? true : _e;
    var _f = React.useState(''), manifestUrl = _f[0], setManifestUrl = _f[1];
    var domain = typeof window !== 'undefined' ? window.location.origin : '';
    var getManifestFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var domainPrefixed, manifestResponse, manifestData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    domainPrefixed = isDomainPrefixedToManifestPath
                        ? domain + manifestPath
                        : manifestPath;
                    return [4, fetch(domainPrefixed, {})];
                case 1:
                    manifestResponse = _a.sent();
                    return [4, manifestResponse.json()];
                case 2:
                    manifestData = _a.sent();
                    setManifestUrl(manifestData['main.js']);
                    return [2];
            }
        });
    }); };
    React.useEffect(function () {
        getManifestFile();
    }, []);
    var renderMicroApp = function () {
        var _a, _b;
        (_b = (_a = window[namespace]) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.render({
            selector: "#" + id,
            props: appProps
        });
    };
    React.useEffect(function () {
        if (manifestUrl) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.onload = function () {
                renderMicroApp();
            };
            script.src = isDomainPrefixedToManifestPath
                ? "" + domain + manifestUrl
                : "" + manifestUrl;
            elementRef.current.appendChild(script);
        }
    }, [manifestUrl]);
    React.useEffect(function () {
        var _a;
        if (appProps && ((_a = window[namespace]) === null || _a === void 0 ? void 0 : _a.default)) {
            renderMicroApp();
        }
    }, [appProps]);
    if (!manifestUrl) {
        return null;
    }
    return (React__default.createElement("div", { "data-testid": dataTestId, className: "" + addClasses, ref: elementRef, id: id }));
};

module.exports = MicroAppLoader;
